import { render, staticRenderFns } from "./ResidentialAddress.vue?vue&type=template&id=19eb3a86&"
import script from "./ResidentialAddress.vue?vue&type=script&lang=js&"
export * from "./ResidentialAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19eb3a86')) {
      api.createRecord('19eb3a86', component.options)
    } else {
      api.reload('19eb3a86', component.options)
    }
    module.hot.accept("./ResidentialAddress.vue?vue&type=template&id=19eb3a86&", function () {
      api.rerender('19eb3a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/ResidentialAddress.vue"
export default component.exports